
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.2 12.1"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#d9dadb"}},[_c('path',{attrs:{"d":"M6.2 6.7c1.1.3 1.9.5 1.9.5-.4-.5-.9-1-1.2-1.5C7.5 4.8 8 4.2 8 4.2c-.6.1-1.3.3-1.9.5-.6-.8-.8-1.3-.8-1.3-.2.5-.3 1.1-.3 1.7-1 .4-1.5.7-1.5.7.5.2 1 .4 1.5.5 0 .6.1 1.2.3 1.8.3-.4.6-.9.9-1.4zM11.2 6.4c-.2.2-.4.4-.7.5 0-.5-.1-1-.2-1.4-.1.6-.3 1.1-.6 1.7-.5.1-1.1.1-1.6 0 .3.4.7.7 1.1 1-.2.4-.5.7-.7 1.1.5-.1.9-.3 1.4-.6.2.1.3.2.4.4.2-.3.3-.7.3-1.1.3-.5.6-1 .6-1.6zM11 4.3c-.2-.5-.6-1-1-1.4-.2-.3-.5-.7-.8-1 0 .2 0 .4-.1.6C8.6 2.2 8 2 7.5 2c.5.3.9.7 1.3 1.1-.2.4-.5.8-.8 1.1.5-.1 1-.2 1.5-.2.4.5.7 1 .9 1.5 0-.5 0-1-.1-1.5.2.1.5.2.7.3zM7.5 2c-.4-.2-.8-.4-1.2-.5.2-.2.6-.4.9-.5-.7 0-1.3.1-2 .3-.5 0-.9 0-1.3.1.1.1.2.3.3.5-.4.3-.8.6-1 1 .4-.3.8-.4 1.3-.6l.2.3c.1.3.3.5.5.8.1-.5.3-.9.5-1.3C6.3 2 6.9 2 7.5 2zM2.2 3.6c.3-.3.6-.6 1-.8-.2 0-.5 0-.7.1.1-.4.2-.7.5-1-1 .8-1.7 2-1.9 3.2.1-.3.3-.6.6-.9.1.3.2.5.3.7 0-.4.1-.8.2-1.3zM3.5 5.8c-.4 0-.9.1-1.3.1-.1-.3-.1-.7-.1-1-.3.3-.5.7-.6 1.2-.2 0-.4.1-.5.2l.3.6c0 .5 0 1 .2 1.5.1-.3.2-.6.4-.9l.9.6c-.2-.4-.3-.8-.4-1.3.3-.4.7-.7 1.1-1zM6.2 10.3c-.4-.2-.8-.3-1.1-.6 0-.5.1-1 .2-1.5l-1.2.9c-.4-.3-.8-.6-1.2-1 .1.5.3.9.5 1.3-.3.1-.7.2-1 .1.5.4 1.1.7 1.7.7.3.4.8.7 1.2.8-.1-.2-.2-.5-.2-.8.4.1.8.1 1.1.1z"}}),_c('path',{attrs:{"d":"M8.4 10.2c.1-.3.1-.6 0-.9-.3.4-.6.7-.9 1-.5 0-.9 0-1.4-.1.2.2.5.4.7.5-.3.2-.5.3-.8.4 1.4 0 2.7-.5 3.6-1.4-.3.2-.7.4-1.2.5z"}})])])
          )
        }
      }
    